import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<circle cx=\"5.5\" cy=\"7.5\" r=\"3.5\" fill=\"#615F5A\"></circle><circle cx=\"5.5\" cy=\"7.5\" r=\"1\" fill=\"white\"></circle><rect x=\"11\" y=\"6\" width=\"10\" height=\"3\" fill=\"#615F5A\"></rect><circle cx=\"17.5\" cy=\"16.5\" r=\"3.5\" fill=\"#615F5A\"></circle><circle cx=\"17.5\" cy=\"16.5\" r=\"1\" fill=\"white\"></circle><rect x=\"2\" y=\"15\" width=\"10\" height=\"3\" fill=\"#615F5A\"></rect>", 6)
const _hoisted_8 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_8))
}